import React from "react";
import {
    Box,
    Container,
    Paper,
    Typography,
    Button,
    Avatar
} from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import RefreshIcon from "@mui/icons-material/Refresh";

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        console.error('Error caught by boundary:', error, errorInfo);
    }

    handleReload = () => {
        if ('caches' in window) {
            caches.keys().then(names => {
                names.forEach(name => caches.delete(name));
            });
        }
        window.location.reload();
    };

    render() {
        if (this.state.hasError) {
            return (
                <Box
                    sx={{
                        minHeight: "100vh",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        background: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
                        padding: 3
                    }}
                >
                    <Container maxWidth="sm">
                        <Paper
                            elevation={8}
                            sx={{
                                padding: 6,
                                borderRadius: 3,
                                textAlign: "center"
                            }}
                        >
                            <Avatar
                                sx={{
                                    width: 80,
                                    height: 80,
                                    margin: "0 auto 24px",
                                    bgcolor: "error.light"
                                }}
                            >
                                <ErrorOutlineIcon sx={{ fontSize: 48, color: "white" }} />
                            </Avatar>

                            <Typography variant="h4" component="h1" gutterBottom fontWeight="bold">
                                Algo deu errado
                            </Typography>

                            <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
                                Ocorreu um erro inesperado. Por favor, tente recarregar a página.
                            </Typography>

                            <Button
                                variant="contained"
                                size="large"
                                startIcon={<RefreshIcon />}
                                onClick={this.handleReload}
                                fullWidth
                                sx={{
                                    py: 1.5,
                                    textTransform: "none",
                                    fontSize: "1rem",
                                    fontWeight: 600
                                }}
                            >
                                Recarregar Página
                            </Button>
                        </Paper>
                    </Container>
                </Box>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;